import { useQuery } from "@apollo/client";
import { LoadingOverlay, Select } from "@mantine/core";
import { useForm } from "@mantine/form";
import { NON_PAGINATED_DRIVERS } from "apollo/queries"; // Ensure this is the correct query
import { useState } from "react";

export default function DriverFilter({
  onCardClick,
  driver,
  user,
  page,
  fetchData,
  size,
}) {
  const [dropDownData, setDropDownData] = useState([]);
  const form = useForm({
    initialValues: {
      driver: null,
    },
  });

  const { loading: driverLoading } = useQuery(NON_PAGINATED_DRIVERS, {
    onCompleted(data) {
      const driverArr = data.driversNonPaginated.map((item) => ({
        label: item?.user?.name,
        value: user ? item.user.id : item.id,
      }));
      console.log("driverArr", driverArr);
      setDropDownData(driverArr);
    },
  });

  const handleDriverSelect = (selectedObj) => {
    onCardClick(selectedObj);
  };

  return (
    <>
      {driverLoading && <LoadingOverlay visible={driverLoading} />}
      <Select
        placeholder="Filter By Driver"
        style={{ minWidth: "145px" }}
        data={dropDownData}
        value={driver?.value || null}
        onChange={(value) => {
          const selected = value
            ? dropDownData.find((d) => d.value === value)
            : null;
          handleDriverSelect(selected);
        }}
        clearable
        searchable
        withinPortal
      />
    </>
  );
}
